import WeightBtn from './WeightBtn';

export default WeightBtn;
